
document.addEventListener('DOMContentLoaded', () => {
  // =========================
  // MENÚ DE NAVEGACIÓN
  // =========================

  const closeMenu = () => {
    document.body.classList.remove('nav-open');
    document.querySelectorAll('[data-menu-toggle]').forEach(button => {
      button.setAttribute('aria-expanded', 'false');
    });
  };

  document.querySelectorAll('[data-menu-toggle]').forEach(button => {
    button.addEventListener('click', () => {
      const isOpen = document.body.classList.toggle('nav-open');
      button.setAttribute('aria-expanded', String(isOpen));
    });
  });

  document.querySelectorAll('[data-menu-close], .mobile-menu-panel a').forEach(item => {
    item.addEventListener('click', closeMenu);
  });

  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') closeMenu();
  });

  // =========================
  // BUSCADOR PREDICTIVO
  // =========================

  document.querySelectorAll('[data-predictive-search-form]').forEach(form => {
    const input = form.querySelector('[data-predictive-search-input]');
    const results = form.querySelector('[data-predictive-search-results]');
    if (!input || !results) return;

    let debounceTimer;
    let requestController;

    const positionResults = () => {
      if (!window.matchMedia('(min-width: 821px)').matches) {
        results.style.removeProperty('top');
        results.style.removeProperty('left');
        results.style.removeProperty('width');
        return;
      }

      const rect = form.getBoundingClientRect();
      results.style.top = `${rect.bottom + 10}px`;
      results.style.left = `${rect.left}px`;
      results.style.width = `${rect.width}px`;
    };

    const closeResults = () => {
      results.hidden = true;
      input.setAttribute('aria-expanded', 'false');
    };

    const openResults = () => {
      positionResults();
      results.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    };

    const fetchResults = async query => {
      if (requestController) requestController.abort();
      requestController = new AbortController();

      results.innerHTML = '<div class="predictive-search__loading">Buscando productos...</div>';
      openResults();

      const root = window.Shopify?.routes?.root || '/';
      const parameters = new URLSearchParams({
        q: query,
        'resources[type]': 'product',
        'resources[limit]': '6',
        'resources[options][unavailable_products]': 'last',
        'resources[options][fields]': 'title,product_type,tag,vendor,variants.title,variants.sku,variants.barcode,body',
        section_id: 'predictive-search'
      });

      try {
        const response = await fetch(
          `${root}search/suggest?${parameters.toString()}`,
          { signal: requestController.signal }
        );

        if (!response.ok) throw new Error(`Error de búsqueda: ${response.status}`);

        const markup = await response.text();
        const section = new DOMParser()
          .parseFromString(markup, 'text/html')
          .querySelector('#shopify-section-predictive-search');

        results.innerHTML = section?.innerHTML || markup;

        if (input.value.trim() === query) openResults();
      } catch (error) {
        if (error.name !== 'AbortError') closeResults();
      }
    };

    input.addEventListener('input', () => {
      window.clearTimeout(debounceTimer);

      const query = input.value.trim();

      if (query.length < 2) {
        requestController?.abort();
        closeResults();
        results.innerHTML = '';
        return;
      }

      debounceTimer = window.setTimeout(() => fetchResults(query), 250);
    });

    form.addEventListener('keydown', event => {
      const links = [...results.querySelectorAll('a')];

      if (event.key === 'Escape') {
        closeResults();
        input.focus();
        return;
      }

      if (!links.length || !['ArrowDown', 'ArrowUp'].includes(event.key)) return;

      event.preventDefault();

      const index = links.indexOf(document.activeElement);
      const next = event.key === 'ArrowDown'
        ? Math.min(index + 1, links.length - 1)
        : Math.max(index - 1, 0);

      links[next].focus();
    });

    document.addEventListener('click', event => {
      if (!form.contains(event.target)) closeResults();
    });

    window.addEventListener('resize', positionResults);
    window.addEventListener('scroll', positionResults, { passive: true });
  });

  // =========================
  // FILTROS DE COLECCIONES
  // =========================

  document.querySelectorAll('[data-collection-filter]').forEach(filter => {
    const input = filter.querySelector('[data-collection-filter-input]');
    const clearButton = filter.querySelector('[data-collection-filter-clear]');
    const summary = filter.querySelector('[data-collection-filter-summary]');
    const emptyState = filter.querySelector('[data-collection-filter-empty]');
    const products = [...filter.querySelectorAll('[data-collection-product]')];

    if (!input || !products.length) return;

    const normalize = value => value
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();

    const searchableProducts = products.map(product => ({
      element: product,
      text: normalize(product.dataset.search || product.textContent || '')
    }));

    const updateResults = () => {
      const query = normalize(input.value);
      const terms = query.split(' ').filter(Boolean);
      let visibleCount = 0;

      searchableProducts.forEach(({ element, text }) => {
        const visible = !terms.length || terms.every(term => text.includes(term));
        element.style.display = visible ? '' : 'none';
        element.hidden = !visible;
        if (visible) visibleCount++;
      });

      if (summary) {
        summary.textContent = terms.length
          ? `${visibleCount} producto${visibleCount === 1 ? '' : 's'} encontrado${visibleCount === 1 ? '' : 's'}`
          : summary.dataset.defaultText;
      }

      if (emptyState) emptyState.hidden = !terms.length || visibleCount > 0;
      if (clearButton) clearButton.hidden = !terms.length;
    };

    clearButton?.addEventListener('click', () => {
      input.value = '';
      input.focus();
      updateResults();
    });

    input.addEventListener('input', updateResults);
    updateResults();
  });

  // =====================================
  // GALERÍA MÓVIL CON ZOOM SC AUTOPARTES
  // =====================================

  if (!document.getElementById('sc-mobile-lightbox-styles')) {
    const style = document.createElement('style');
    style.id = 'sc-mobile-lightbox-styles';

    style.textContent = `
      @media (max-width: 820px) {
        [data-product-gallery] .product-detail__main-image {
          cursor: zoom-in;
        }

        [data-product-gallery] .product-detail__thumbnails,
        [data-product-gallery] .product-gallery__mobile-hint {
          display: none !important;
        }

        [data-product-gallery] .product-detail__media {
          max-width: 100%;
          min-width: 0;
        }
      }

      .sc-mobile-lightbox[hidden] {
        display: none !important;
      }

      .sc-mobile-lightbox {
        position: fixed;
        inset: 0;
        z-index: 2147483646;
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;
        height: 100dvh;
        padding:
          max(12px, env(safe-area-inset-top))
          12px
          max(12px, env(safe-area-inset-bottom));
        box-sizing: border-box;
        background: rgba(8, 20, 40, .97);
        color: #fff;
      }

      .sc-mobile-lightbox__header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        min-height: 48px;
        gap: 12px;
      }

      .sc-mobile-lightbox__count {
        font: 600 14px/1.3 Arial, sans-serif;
      }

      .sc-mobile-lightbox__close {
        width: 44px;
        height: 44px;
        border: 0;
        border-radius: 50%;
        background: rgba(255,255,255,.14);
        color: #fff;
        font-size: 30px;
        cursor: pointer;
      }

      .sc-mobile-lightbox__stage {
        position: relative;
        display: flex;
        flex: 1 1 auto;
        align-items: center;
        justify-content: center;
        min-height: 0;
        overflow: hidden;
        touch-action: none;
      }

      .sc-mobile-lightbox__image {
        display: block;
        width: 100%;
        height: 100%;
        max-width: 100%;
        max-height: 100%;
        object-fit: contain;
        transform-origin: center center;
        will-change: transform;
        user-select: none;
        -webkit-user-select: none;
        -webkit-user-drag: none;
      }

      .sc-mobile-lightbox__arrow {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        width: 44px;
        height: 48px;
        border: 0;
        border-radius: 12px;
        background: rgba(8,20,40,.48);
        color: #fff;
        font-size: 32px;
        cursor: pointer;
      }

      .sc-mobile-lightbox__arrow--previous {
        left: 0;
      }

      .sc-mobile-lightbox__arrow--next {
        right: 0;
      }

      .sc-mobile-lightbox__zoom {
        display: flex;
        align-items: center;
        gap: 10px;
        justify-content: center;
      }

      .sc-mobile-lightbox__zoom button {
        min-height: 44px;
        min-width: 44px;
        border: 1px solid rgba(255,255,255,.3);
        border-radius: 12px;
        color: white;
        background: rgba(255,255,255,.12);
        font-size: 24px;
      }

      .sc-mobile-lightbox__zoom button:disabled {
        opacity: .45;
      }

      .sc-mobile-lightbox__help {
        margin: 8px 0 2px;
        text-align: center;
        font: 500 12px/1.4 Arial, sans-serif;
        color: #d0d9e7;
      }

      @media (min-width: 821px) {
        .sc-mobile-lightbox {
          display: none !important;
        }
      }
    `;

    document.head.appendChild(style);
  }

  document.querySelectorAll('[data-product-gallery]').forEach(gallery => {
    const mainImage = gallery.querySelector('.product-detail__main-image');
    const media = gallery.querySelector('.product-detail__media');
    const thumbnails = [...gallery.querySelectorAll('[data-gallery-image]')];

    if (!mainImage) return;

    let activeIndex = Math.max(
      0,
      thumbnails.findIndex(thumbnail => thumbnail.classList.contains('is-active'))
    );

    const mobileOnly = () =>
      window.matchMedia('(max-width: 820px)').matches;

    const showImage = index => {
      if (!thumbnails.length) return;

      activeIndex = (index + thumbnails.length) % thumbnails.length;
      const selected = thumbnails[activeIndex];

      mainImage.removeAttribute('srcset');
      mainImage.removeAttribute('sizes');
      mainImage.src = selected.dataset.galleryImage;

      thumbnails.forEach(thumbnail => thumbnail.classList.remove('is-active'));
      selected.classList.add('is-active');

      if (!mobileOnly()) {
        selected.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'nearest'
        });
      }
    };

    thumbnails.forEach((thumbnail, index) => {
      thumbnail.addEventListener('click', () => showImage(index));
    });

    const lightbox = document.createElement('div');
    lightbox.className = 'sc-mobile-lightbox';
    lightbox.hidden = true;
    lightbox.setAttribute('role', 'dialog');
    lightbox.setAttribute('aria-modal', 'true');
    lightbox.setAttribute('aria-label', 'Fotografías del producto');

    lightbox.innerHTML = `
      <div class="sc-mobile-lightbox__header">
        <span class="sc-mobile-lightbox__count" aria-live="polite"></span>
        <button
          type="button"
          class="sc-mobile-lightbox__close"
          aria-label="Cerrar galería"
        >&times;</button>
      </div>

      <div class="sc-mobile-lightbox__stage">
        <img
          class="sc-mobile-lightbox__image"
          alt="Fotografía ampliada del producto"
        >

        <button
          type="button"
          class="sc-mobile-lightbox__arrow sc-mobile-lightbox__arrow--previous"
          aria-label="Foto anterior"
        >&#8249;</button>

        <button
          type="button"
          class="sc-mobile-lightbox__arrow sc-mobile-lightbox__arrow--next"
          aria-label="Foto siguiente"
        >&#8250;</button>
      </div>

      <div class="sc-mobile-lightbox__zoom">
        <button type="button" data-sc-zoom-out aria-label="Reducir fotografía">−</button>
        <span data-sc-zoom-level aria-live="polite">100%</span>
        <button type="button" data-sc-zoom-in aria-label="Ampliar fotografía">+</button>
      </div>

      <p class="sc-mobile-lightbox__help">
        Pellizca o toca dos veces para ampliar
      </p>
    `;

    document.body.appendChild(lightbox);

    const lightboxImage = lightbox.querySelector('.sc-mobile-lightbox__image');
    const lightboxCount = lightbox.querySelector('.sc-mobile-lightbox__count');
    const lightboxClose = lightbox.querySelector('.sc-mobile-lightbox__close');
    const lightboxStage = lightbox.querySelector('.sc-mobile-lightbox__stage');
    const lightboxArrows = lightbox.querySelectorAll('.sc-mobile-lightbox__arrow');
    const zoomLevel = lightbox.querySelector('[data-sc-zoom-level]');
    const zoomOut = lightbox.querySelector('[data-sc-zoom-out]');
    const zoomIn = lightbox.querySelector('[data-sc-zoom-in]');

    let lastFocused = null;
    let previousOverflow = '';
    let scale = 1;
    let offsetX = 0;
    let offsetY = 0;
    let swipedAt = 0;

    const clamp = (value, min, max) =>
      Math.max(min, Math.min(max, value));

    const renderZoom = () => {
      const bounds = lightboxStage.getBoundingClientRect();

      const maxX = Math.max(0, scale - 1) * bounds.width / 2;
      const maxY = Math.max(0, scale - 1) * bounds.height / 2;

      offsetX = clamp(offsetX, -maxX, maxX);
      offsetY = clamp(offsetY, -maxY, maxY);

      lightboxImage.style.transform =
        `translate3d(${offsetX}px, ${offsetY}px, 0) scale(${scale})`;

      zoomLevel.textContent = `${Math.round(scale * 100)}%`;
      zoomOut.disabled = scale <= 1;
      zoomIn.disabled = scale >= 4;
    };

    const setZoom = value => {
      scale = clamp(value, 1, 4);

      if (scale === 1) {
        offsetX = 0;
        offsetY = 0;
      }

      renderZoom();
    };

    zoomIn.addEventListener('click', () => setZoom(scale + .5));
    zoomOut.addEventListener('click', () => setZoom(scale - .5));

    const updateLightbox = () => {
      setZoom(1);

      const count = thumbnails.length || 1;
      const selected = thumbnails[activeIndex];

      lightboxImage.src =
        selected?.dataset.galleryImage || mainImage.currentSrc || mainImage.src;

      lightboxImage.alt = mainImage.alt || 'Fotografía del repuesto';

      lightboxCount.textContent =
        `${activeIndex + 1} de ${count} fotos`;

      lightboxArrows.forEach(arrow => {
        arrow.hidden = count < 2;
      });
    };

    const openLightbox = () => {
      if (!mobileOnly() || !lightbox.hidden) return;

      lastFocused = document.activeElement;
      previousOverflow = document.body.style.overflow;

      lightbox.hidden = false;
      document.body.style.overflow = 'hidden';

      updateLightbox();
      lightboxClose.focus();
    };

    const closeLightbox = () => {
      if (lightbox.hidden) return;

      lightbox.hidden = true;
      document.body.style.overflow = previousOverflow;

      if (lastFocused?.isConnected) {
        lastFocused.focus({ preventScroll: true });
      }
    };

    const nextLightboxImage = step => {
      if (scale > 1) return;

      if (thumbnails.length > 1) {
        showImage(activeIndex + step);
      }

      updateLightbox();
    };

    media?.addEventListener('click', event => {
      if (!mobileOnly()) return;
      if (Date.now() - swipedAt < 450) return;
      if (event.target.closest('button')) return;

      const clickedLink = event.target.closest('a');
      if (clickedLink && !clickedLink.contains(mainImage)) return;

      event.preventDefault();
      openLightbox();
    });

    lightboxClose.addEventListener('click', closeLightbox);

    lightbox.querySelector('.sc-mobile-lightbox__arrow--previous')
      .addEventListener('click', () => nextLightboxImage(-1));

    lightbox.querySelector('.sc-mobile-lightbox__arrow--next')
      .addEventListener('click', () => nextLightboxImage(1));

    lightbox.addEventListener('keydown', event => {
      if (event.key === 'Escape') {
        event.preventDefault();
        closeLightbox();
      }

      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        nextLightboxImage(-1);
      }

      if (event.key === 'ArrowRight') {
        event.preventDefault();
        nextLightboxImage(1);
      }

      if (event.key === '+' || event.key === '=') {
        event.preventDefault();
        setZoom(scale + .5);
      }

      if (event.key === '-') {
        event.preventDefault();
        setZoom(scale - .5);
      }

      if (event.key === 'Tab') {
        const controls = [
          lightboxClose,
          ...lightboxArrows,
          zoomOut,
          zoomIn
        ].filter(item => !item.hidden && !item.disabled);

        const first = controls[0];
        const last = controls[controls.length - 1];

        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }
    });

    // Gestos táctiles: zoom, arrastrar y cambiar fotos

    let gesture = null;
    let lastTap = 0;

    const touchDistance = touches => Math.hypot(
      touches[0].clientX - touches[1].clientX,
      touches[0].clientY - touches[1].clientY
    );

    lightboxStage.addEventListener('touchstart', event => {
      if (event.touches.length === 2) {
        gesture = {
          mode: 'pinch',
          distance: touchDistance(event.touches),
          initialScale: scale
        };
      } else if (event.touches.length === 1) {
        const touch = event.touches[0];

        gesture = {
          mode: scale > 1 ? 'pan' : 'swipe',
          x: touch.clientX,
          y: touch.clientY,
          initialX: offsetX,
          initialY: offsetY
        };
      }
    }, { passive: true });

    lightboxStage.addEventListener('touchmove', event => {
      if (!gesture) return;
      if (event.cancelable) event.preventDefault();

      if (event.touches.length === 2) {
        if (gesture.mode !== 'pinch') {
          gesture = {
            mode: 'pinch',
            distance: touchDistance(event.touches),
            initialScale: scale
          };
        }

        setZoom(
          gesture.initialScale *
          touchDistance(event.touches) /
          Math.max(1, gesture.distance)
        );
      } else if (event.touches.length === 1 && gesture.mode === 'pan') {
        offsetX =
          gesture.initialX + event.touches[0].clientX - gesture.x;

        offsetY =
          gesture.initialY + event.touches[0].clientY - gesture.y;

        renderZoom();
      }
    }, { passive: false });

    lightboxStage.addEventListener('touchend', event => {
      if (!gesture) return;

      if (event.touches.length) {
        gesture = null;
        return;
      }

      const touch = event.changedTouches[0];

      if (gesture.mode === 'swipe') {
        const dx = touch.clientX - gesture.x;
        const dy = touch.clientY - gesture.y;

        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) {
          nextLightboxImage(dx < 0 ? 1 : -1);
          lastTap = 0;
        } else if (Math.abs(dx) < 15 && Math.abs(dy) < 15) {
          const now = Date.now();

          if (now - lastTap < 320) {
            setZoom(scale > 1 ? 1 : 2.5);
            lastTap = 0;
          } else {
            lastTap = now;
          }
        }
      } else if (gesture.mode === 'pan') {
        const dx = touch.clientX - gesture.x;
        const dy = touch.clientY - gesture.y;

        if (Math.abs(dx) < 15 && Math.abs(dy) < 15) {
          const now = Date.now();

          if (now - lastTap < 320) {
            setZoom(1);
            lastTap = 0;
          } else {
            lastTap = now;
          }
        }
      }

      gesture = null;
    }, { passive: true });

    window.addEventListener('resize', () => {
      if (!mobileOnly()) closeLightbox();
    });

    gallery.querySelector('[data-gallery-previous]')
      ?.addEventListener('click', () => showImage(activeIndex - 1));

    gallery.querySelector('[data-gallery-next]')
      ?.addEventListener('click', () => showImage(activeIndex + 1));

    gallery.addEventListener('keydown', event => {
      if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
      if (!lightbox.hidden) return;

      event.preventDefault();
      showImage(activeIndex + (event.key === 'ArrowRight' ? 1 : -1));
    });

    let touchStartX = 0;

    media?.addEventListener('touchstart', event => {
      touchStartX = event.changedTouches[0].clientX;
    }, { passive: true });

    media?.addEventListener('touchend', event => {
      const distance =
        event.changedTouches[0].clientX - touchStartX;

      if (Math.abs(distance) < 45) return;

      swipedAt = Date.now();
      showImage(activeIndex + (distance < 0 ? 1 : -1));
    }, { passive: true });
  });

  // =========================
  // FORMULARIOS Y STOCK
  // =========================

  document.querySelectorAll('[data-product-purchase-form]').forEach(form => {
    const variantInput = form.querySelector('[data-product-variant-input]');
    const quantityInput = form.querySelector('[data-product-quantity-input]');
    const minusButton = form.querySelector('[data-product-quantity-minus]');
    const plusButton = form.querySelector('[data-product-quantity-plus]');
    const stockText = form.querySelector('[data-product-stock]');

    const availabilityText = form.closest('.product-detail__panel')
      ?.querySelector('[data-product-availability]');

    const addButton = form.querySelector('[data-product-add-stay]');
    const feedback = form.querySelector('[data-product-add-feedback]');
    const quantityContainer = form.querySelector('[data-product-quantity]');
    const purchaseControls = form.querySelector('[data-product-purchase-controls]');
    const stockInquiry = form.querySelector('[data-product-out-of-stock-whatsapp]');
    const generalWhatsapp = form.querySelector('[data-product-general-whatsapp]');

    const getVariantMeta = () => {
      const source = variantInput?.tagName === 'SELECT'
        ? variantInput.options[variantInput.selectedIndex]
        : variantInput;

      const stockQuantity = Number(source?.dataset.stockQuantity || 0);
      const isLimited = source?.dataset.stockLimited === 'true';
      const isTracked = source?.dataset.stockTracked === 'true';
      const isAvailable = source?.dataset.available !== 'false';

      const isAvailableToOrder =
        isAvailable && isTracked && stockQuantity <= 0 && !isLimited;

      return {
        stockQuantity,
        isLimited,
        isTracked,
        isAvailable,
        isAvailableToOrder
      };
    };

    const clampQuantity = () => {
      if (!quantityInput) return 1;

      const { stockQuantity, isLimited } = getVariantMeta();

      const max = isLimited ? Math.max(0, stockQuantity) : null;
      let value = Math.max(1, Number(quantityInput.value || 1));

      if (max !== null) {
        value = Math.min(value, Math.max(1, max));
      }

      quantityInput.value = String(value);
      return value;
    };

    const updateStockState = () => {
      const {
        stockQuantity,
        isLimited,
        isTracked,
        isAvailable,
        isAvailableToOrder
      } = getVariantMeta();

      const canPurchase =
        isAvailable &&
        (!isTracked || stockQuantity > 0 || isAvailableToOrder);

      const buyButton = form.querySelector('[type="submit"]');
      const buyButtonLabel = buyButton?.querySelector('span');

      if (quantityInput) {
        if (isLimited) {
          quantityInput.max = String(Math.max(0, stockQuantity));
        } else {
          quantityInput.removeAttribute('max');
        }

        quantityInput.disabled = !canPurchase;
      }

      if (addButton) addButton.disabled = !canPurchase;
      buyButton?.toggleAttribute('disabled', !canPurchase);

      if (buyButtonLabel) {
        buyButtonLabel.textContent = isAvailableToOrder
          ? 'Comprar a pedido'
          : (buyButtonLabel.dataset.defaultLabel || 'Comprar');
      }

      if (quantityContainer) quantityContainer.hidden = !canPurchase;
      if (purchaseControls) purchaseControls.hidden = !canPurchase;
      if (stockInquiry) stockInquiry.hidden = canPurchase;
      if (generalWhatsapp) generalWhatsapp.hidden = !canPurchase;

      if (availabilityText) {
        availabilityText.textContent = !canPurchase
          ? (
              availabilityText.dataset.availableToOrderText ||
              'Disponible a pedido — Un ejecutivo confirmará disponibilidad, pago y plazo de entrega.'
            )
          : isAvailableToOrder
            ? (
                availabilityText.dataset.availableToOrderText ||
                'Disponible a pedido — Un ejecutivo confirmará disponibilidad, pago y plazo de entrega.'
              )
            : isTracked
              ? `${Math.max(0, stockQuantity)} ${stockQuantity === 1 ? 'unidad disponible' : 'unidades disponibles'}`
              : (availabilityText.dataset.availableText || 'Disponible');
      }

      if (stockText) {
        stockText.textContent = !canPurchase
          ? ''
          : isAvailableToOrder
            ? 'Disponible a pedido — Un ejecutivo confirmará disponibilidad, pago y plazo de entrega.'
            : isTracked
              ? `Stock disponible: ${Math.max(0, stockQuantity)}`
              : 'Stock disponible';
      }

      clampQuantity();
    };

    const setFeedback = (message, isError = false) => {
      if (!feedback) return;

      feedback.textContent = message;
      feedback.hidden = false;
      feedback.classList.toggle('is-error', isError);

      window.clearTimeout(feedback._hideTimer);

      feedback._hideTimer = window.setTimeout(() => {
        feedback.hidden = true;
      }, 3200);
    };

    variantInput?.addEventListener('change', updateStockState);
    quantityInput?.addEventListener('input', clampQuantity);

    minusButton?.addEventListener('click', () => {
      if (!quantityInput) return;

      quantityInput.value = String(
        Math.max(1, Number(quantityInput.value || 1) - 1)
      );

      clampQuantity();
    });

    plusButton?.addEventListener('click', () => {
      if (!quantityInput) return;

      quantityInput.value =
        String(Number(quantityInput.value || 1) + 1);

      clampQuantity();
    });

    addButton?.addEventListener('click', async () => {
      const { stockQuantity, isLimited } = getVariantMeta();
      const quantity = clampQuantity();

      addButton.disabled = true;

      const label = addButton.querySelector('span');
      const originalLabel = label?.textContent;

      if (label) label.textContent = 'Agregando...';

      try {
        const root = window.Shopify?.routes?.root || '/';

        const cartResponseBeforeAdd = await fetch(`${root}cart.js`, {
          headers: { Accept: 'application/json' }
        });

        const cartBeforeAdd = cartResponseBeforeAdd.ok
          ? await cartResponseBeforeAdd.json()
          : null;

        const variantId = Number(new FormData(form).get('id'));

        const currentQuantity = cartBeforeAdd?.items
          ?.filter(item => Number(item.variant_id) === variantId)
          ?.reduce((total, item) => total + item.quantity, 0) || 0;

        const availableToAdd = isLimited
          ? Math.max(0, stockQuantity - currentQuantity)
          : null;

        if (availableToAdd !== null && quantity > availableToAdd) {
          const message = availableToAdd > 0
            ? `Puedes agregar ${availableToAdd} más de este producto.`
            : 'Ya agregaste todo el stock disponible de este producto.';

          setFeedback(message, true);
          return;
        }

        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        });

        if (!response.ok) {
          throw new Error('No se pudo agregar al carrito.');
        }

        const cartResponse = await fetch(`${root}cart.js`, {
          headers: { Accept: 'application/json' }
        });

        if (cartResponse.ok) {
          const cart = await cartResponse.json();

          document.querySelectorAll('.cart-link em').forEach(counter => {
            counter.textContent = cart.item_count;
          });
        }

        setFeedback('Producto agregado al carrito.');
      } catch (error) {
        setFeedback('No se pudo agregar. Intenta nuevamente.', true);
      } finally {
        addButton.disabled = false;

        if (label && originalLabel) {
          label.textContent = originalLabel;
        }
      }
    });

    updateStockState();
  });

  // =========================
  // CARRITO
  // =========================

  const cartRoot = window.Shopify?.routes?.root || '/';

  const formatCartMoney = cents =>
    new Intl.NumberFormat('es-CL', {
      style: 'currency',
      currency: 'CLP',
      maximumFractionDigits: 0
    }).format(Number(cents || 0) / 100);

  const escapeCartHtml = value => String(value || '')
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#039;');

  const updateCartCounters = cart => {
    document.querySelectorAll('.cart-link em').forEach(counter => {
      counter.textContent = cart.item_count;
    });
  };

  const getCart = async () => {
    const response = await fetch(`${cartRoot}cart.js`, {
      headers: { Accept: 'application/json' }
    });

    if (!response.ok) {
      throw new Error('No se pudo cargar el carrito.');
    }

    return response.json();
  };

  const cartPreviewMarkup = cart => {
    if (!cart.item_count) {
      return `
        <div class="sc-cart-preview__head">
          <div>
            <span>SC Autopartes</span>
            <strong>Tu carrito</strong>
          </div>
          <span>0 productos</span>
        </div>
        <div class="sc-cart-preview__empty">
          <span aria-hidden="true">SC</span>
          <strong>Tu carrito está vacío</strong>
          <p>Encuentra el repuesto que necesitas y agrégalo aquí.</p>
          <a class="button button--primary" href="${cartRoot}collections/all">Ver productos</a>
        </div>`;
    }

    const items = cart.items.slice(0, 4).map(item => {
      const image = item.image
        ? `<img src="${escapeCartHtml(item.image)}" alt="" loading="lazy">`
        : '<span class="sc-cart-preview__placeholder">SC</span>';

      return `
        <article class="sc-cart-preview__item">
          <a class="sc-cart-preview__image" href="${escapeCartHtml(item.url)}">${image}</a>
          <div>
            <a class="sc-cart-preview__title" href="${escapeCartHtml(item.url)}">${escapeCartHtml(item.product_title)}</a>
            <span>${item.quantity} × ${formatCartMoney(item.final_price)}</span>
          </div>
          <strong>${formatCartMoney(item.final_line_price)}</strong>
        </article>`;
    }).join('');

    const remaining = cart.items.length > 4
      ? `<p class="sc-cart-preview__remaining">Y ${cart.items.length - 4} producto${cart.items.length - 4 === 1 ? '' : 's'} más</p>`
      : '';

    return `
      <div class="sc-cart-preview__head">
        <div>
          <span>SC Autopartes</span>
          <strong>Tu carrito</strong>
        </div>
        <span>${cart.item_count} ${cart.item_count === 1 ? 'producto' : 'productos'}</span>
      </div>

      <div class="sc-cart-preview__items">${items}</div>
      ${remaining}

      <div class="sc-cart-preview__total">
        <span>Subtotal</span>
        <strong>${formatCartMoney(cart.items_subtotal_price)}</strong>
      </div>

      <div class="sc-cart-preview__buttons">
        <a class="button button--outline" href="${cartRoot}cart">Ver carrito</a>
        <a class="button button--primary" href="${cartRoot}checkout">Finalizar compra</a>
      </div>

      <button class="sc-cart-preview__clear" type="button" data-cart-preview-clear>Vaciar carrito</button>`;
  };

  const renderCartPreviews = cart => {
    updateCartCounters(cart);

    document.querySelectorAll('[data-cart-preview]').forEach(preview => {
      preview.innerHTML = cartPreviewMarkup(cart);
      preview.dataset.loaded = 'true';
    });
  };

  const refreshCartPage = async cart => {
    updateCartCounters(cart);

    const currentMain = document.querySelector('#MainContent');

    if (
      !currentMain ||
      !document.querySelector('[data-cart-form], .sc-cart-empty')
    ) return;

    const response = await fetch(`${cartRoot}cart`, {
      headers: { Accept: 'text/html' }
    });

    if (!response.ok) {
      throw new Error('No se pudo actualizar la vista del carrito.');
    }

    const documentCopy = new DOMParser()
      .parseFromString(await response.text(), 'text/html');

    const nextMain = documentCopy.querySelector('#MainContent');
    if (!nextMain) return;

    currentMain.innerHTML = nextMain.innerHTML;
    initCartPage();
  };

  let cartUpdateTimer;
  let cartRequestRunning = false;

  const updateCart = async (updates, statusElement) => {
    if (cartRequestRunning) return;

    cartRequestRunning = true;

    const form = document.querySelector('[data-cart-form]');
    form?.classList.add('is-updating');

    if (statusElement) {
      statusElement.textContent = 'Actualizando...';
    }

    try {
      const response = await fetch(`${cartRoot}cart/update.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({ updates })
      });

      if (!response.ok) {
        throw new Error('No se pudo actualizar el carrito.');
      }

      const cart = await response.json();

      renderCartPreviews(cart);
      await refreshCartPage(cart);
    } catch (error) {
      form?.classList.remove('is-updating');

      if (statusElement) {
        statusElement.textContent =
          'No se pudo actualizar. Intenta nuevamente.';
      }
    } finally {
      cartRequestRunning = false;
    }
  };

  function initCartPage() {
    const form = document.querySelector('[data-cart-form]');

    if (!form || form.dataset.cartReady === 'true') return;

    form.dataset.cartReady = 'true';

    const status = form.querySelector('[data-cart-status]');

    const queueUpdate = (key, quantity) => {
      window.clearTimeout(cartUpdateTimer);

      if (status) {
        status.textContent = 'Guardando cambio...';
      }

      cartUpdateTimer = window.setTimeout(
        () => updateCart({ [key]: quantity }, status),
        320
      );
    };

    form.querySelectorAll('[data-cart-quantity]').forEach(control => {
      const input = control.querySelector('[data-quantity-input]');
      const minus = control.querySelector('[data-quantity-minus]');
      const plus = control.querySelector('[data-quantity-plus]');

      if (!input) return;

      const commit = quantity => {
        const nextQuantity = Math.max(
          Number(input.min || 0),
          quantity
        );

        input.value = String(nextQuantity);
        queueUpdate(input.dataset.cartKey, nextQuantity);
      };

      minus?.addEventListener('click', () => {
        commit(Number(input.value || 0) - 1);
      });

      plus?.addEventListener('click', () => {
        commit(Number(input.value || 0) + 1);
      });

      input.addEventListener('change', () => {
        commit(Number(input.value || 0));
      });

      input.addEventListener('keydown', event => {
        if (event.key === 'Enter') {
          event.preventDefault();
          commit(Number(input.value || 0));
        }
      });
    });

    form.querySelectorAll('[data-cart-remove]').forEach(removeLink => {
      removeLink.addEventListener('click', event => {
        event.preventDefault();
        queueUpdate(removeLink.dataset.cartKey, 0);
      });
    });

    form.querySelector('[data-cart-clear]')?.addEventListener('click', () => {
      if (!window.confirm('¿Quieres vaciar completamente el carrito?')) return;

      const updates = {};

      form.querySelectorAll('[data-quantity-input]').forEach(input => {
        updates[input.dataset.cartKey] = 0;
      });

      updateCart(updates, status);
    });
  }

  // =========================
  // VISTA PREVIA DEL CARRITO
  // =========================

  document.querySelectorAll('[data-cart-preview-wrap]').forEach(wrapper => {
    const trigger = wrapper.querySelector('[data-cart-preview-trigger]');
    const preview = wrapper.querySelector('[data-cart-preview]');

    if (!trigger || !preview) return;

    let closeTimer;

    const openPreview = async () => {
      window.clearTimeout(closeTimer);

      preview.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');

      preview.innerHTML =
        '<div class="sc-cart-preview__loading">Cargando carrito...</div>';

      try {
        renderCartPreviews(await getCart());
      } catch (error) {
        preview.innerHTML =
          '<div class="sc-cart-preview__loading">No pudimos cargar el carrito.</div>';
      }
    };

    const closePreview = () => {
      closeTimer = window.setTimeout(() => {
        preview.hidden = true;
        trigger.setAttribute('aria-expanded', 'false');
      }, 180);
    };

    wrapper.addEventListener('mouseenter', openPreview);
    wrapper.addEventListener('mouseleave', closePreview);
    trigger.addEventListener('focus', openPreview);

    wrapper.addEventListener('focusout', event => {
      if (!wrapper.contains(event.relatedTarget)) {
        closePreview();
      }
    });

    trigger.addEventListener('click', event => {
      if (
        window.matchMedia('(hover: none)').matches &&
        preview.hidden
      ) {
        event.preventDefault();
        openPreview();
      }
    });
  });

  document.addEventListener('click', async event => {
    const clearButton = event.target.closest('[data-cart-preview-clear]');

    if (!clearButton) return;
    if (!window.confirm('¿Quieres vaciar completamente el carrito?')) return;

    clearButton.disabled = true;
    clearButton.textContent = 'Vaciando...';

    try {
      const response = await fetch(`${cartRoot}cart/clear.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' }
      });

      if (!response.ok) {
        throw new Error('No se pudo vaciar el carrito.');
      }

      const cart = await response.json();

      renderCartPreviews(cart);
      await refreshCartPage(cart);
    } catch (error) {
      clearButton.disabled = false;
      clearButton.textContent = 'No se pudo vaciar. Reintentar';
    }
  });

  initCartPage();
});


/* ===================================================
   SC AUTOPARTES
   MINIATURAS DE PRODUCTO DEBAJO DE LA FOTO PRINCIPAL
   Exclusivo para celulares
   Conserva la galería ampliada y el zoom existente
   =================================================== */

document.addEventListener('DOMContentLoaded', () => {

  const MOBILE_WIDTH = 820;

  const mobileQuery = window.matchMedia(
    `(max-width: ${MOBILE_WIDTH}px)`
  );

  /* Agregar estilos para las miniaturas */

  if (!document.getElementById('sc-thumbnails-bottom-css')) {

    const style = document.createElement('style');

    style.id = 'sc-thumbnails-bottom-css';

    style.textContent = `

      @media screen and (max-width: 820px) {

        /* Contenedor principal de galería */

        [data-product-gallery] {
          display: flex !important;
          flex-direction: column !important;
          width: 100% !important;
          max-width: 100% !important;
          min-width: 0 !important;
        }

        /* Fotografía principal */

        [data-product-gallery] .product-detail__media {
          order: 1 !important;
          display: grid !important;
          position: relative !important;
          width: 100% !important;
          max-width: 100% !important;
          min-width: 0 !important;
          overflow: hidden !important;
          flex-shrink: 0 !important;
        }

        [data-product-gallery] .product-detail__main-image {
          width: 100% !important;
          height: 100% !important;
          max-width: 100% !important;
          object-fit: contain !important;
          cursor: zoom-in !important;
        }

        /* Fila de miniaturas debajo */

        [data-product-gallery] .product-detail__thumbnails {
          order: 2 !important;
          display: flex !important;
          flex-direction: row !important;
          flex-wrap: nowrap !important;
          align-items: center !important;
          justify-content: flex-start !important;
          gap: 8px !important;

          width: 100% !important;
          max-width: 100% !important;
          min-width: 0 !important;

          margin: 0 !important;
          padding: 10px 2px 8px !important;

          overflow-x: auto !important;
          overflow-y: hidden !important;

          scroll-snap-type: x proximity;
          scrollbar-width: thin;
          -webkit-overflow-scrolling: touch;
          overscroll-behavior-x: contain;
        }

        /* Cada miniatura */

        [data-product-gallery] .product-detail__thumbnail {
          display: flex !important;
          flex: 0 0 64px !important;

          align-items: center !important;
          justify-content: center !important;

          width: 64px !important;
          height: 64px !important;

          min-width: 64px !important;
          max-width: 64px !important;

          padding: 5px !important;

          background: #ffffff !important;

          border: 1px solid #dce3f0 !important;
          border-radius: 10px !important;

          box-shadow: none !important;

          cursor: pointer !important;
          scroll-snap-align: start;
        }

        /* Miniatura seleccionada */

        [data-product-gallery] .product-detail__thumbnail.is-active {
          border: 2px solid #0A4EC6 !important;
          box-shadow: 0 0 0 1px rgba(10,78,198,.12) !important;
        }

        /* Imagen de cada miniatura */

        [data-product-gallery] .product-detail__thumbnail-image {
          display: block !important;

          width: 100% !important;
          height: 100% !important;

          max-width: 100% !important;
          max-height: 100% !important;

          object-fit: contain !important;
          border-radius: 6px !important;
        }

        /* Ocultar mensaje antiguo */

        [data-product-gallery] .product-gallery__mobile-hint {
          display: none !important;
        }

      }

    `;

    document.head.appendChild(style);

  }

  /* Recuperar la posición de las miniaturas */

  document.querySelectorAll('[data-product-gallery]').forEach(gallery => {

    const media = gallery.querySelector(
      '.product-detail__media'
    );

    const thumbnailsContainer = gallery.querySelector(
      '.product-detail__thumbnails'
    );

    if (!media || !thumbnailsContainer) return;

    /* Guardar ubicación original para escritorio */

    const originalParent = thumbnailsContainer.parentNode;

    const originalNextSibling = thumbnailsContainer.nextSibling;

    /* Ajustar posición según tamaño de pantalla */

    const updateGalleryLayout = () => {

      if (mobileQuery.matches) {

        /* Colocar miniaturas inmediatamente después de la foto */

        if (media.nextElementSibling !== thumbnailsContainer) {

          media.insertAdjacentElement(
            'afterend',
            thumbnailsContainer
          );

        }

      } else {

        /* Restaurar ubicación original en computador */

        if (originalParent) {

          if (
            originalNextSibling &&
            originalNextSibling.parentNode === originalParent
          ) {

            originalParent.insertBefore(
              thumbnailsContainer,
              originalNextSibling
            );

          } else {

            originalParent.appendChild(
              thumbnailsContainer
            );

          }

        }

      }

    };

    updateGalleryLayout();

    /* Escuchar cambios entre móvil y escritorio */

    if (mobileQuery.addEventListener) {

      mobileQuery.addEventListener(
        'change',
        updateGalleryLayout
      );

    } else {

      mobileQuery.addListener(updateGalleryLayout);

    }

    /* Centrar miniatura activa dentro de su propia fila */

    const centerActiveThumbnail = () => {

      if (!mobileQuery.matches) return;

      const active = thumbnailsContainer.querySelector(
        '.product-detail__thumbnail.is-active'
      );

      if (!active) return;

      const containerRect =
        thumbnailsContainer.getBoundingClientRect();

      const activeRect = active.getBoundingClientRect();

      const targetScroll =
        thumbnailsContainer.scrollLeft +
        activeRect.left -
        containerRect.left -
        (containerRect.width - activeRect.width) / 2;

      thumbnailsContainer.scrollTo({
        left: Math.max(0, targetScroll),
        behavior: 'smooth'
      });

    };

    /* Mantener sincronización con el carrusel actual */

    thumbnailsContainer.addEventListener('click', event => {

      const thumbnail = event.target.closest(
        '[data-gallery-image]'
      );

      if (!thumbnail) return;

      window.requestAnimationFrame(() => {

        centerActiveThumbnail();

      });

    });

    /* Detectar cambios de foto con las flechas */

    const observer = new MutationObserver(mutations => {

      if (!mobileQuery.matches) return;

      const changed = mutations.some(mutation => {

        return mutation.attributeName === 'class';

      });

      if (changed) {

        centerActiveThumbnail();

      }

    });

    thumbnailsContainer.querySelectorAll(
      '[data-gallery-image]'
    ).forEach(thumbnail => {

      observer.observe(thumbnail, {
        attributes: true,
        attributeFilter: ['class']
      });

    });

  });

});
